import { createContext } from 'react'

const netSuiteContext = createContext()

export default netSuiteContext
